export default __webpack_public_path__ + "static/media/pictogramBeaconSearch40.53779dac.svg";